import type { GetProfileResponse, User } from '../types'
import { api } from './api'

interface UpdateProfileData {
  firstName?: string
  lastName?: string
  email?: string
  phoneNumber?: string
}

interface ChangePasswordData {
  currentPassword: string
  newPassword: string
}

export class ProfileService {
  /**
   * Get current user profile
   */
  static async getProfile(): Promise<GetProfileResponse> {
    return await api.get<GetProfileResponse['response']>('/users/profile')
  }

  /**
   * Update user profile
   */
  static async updateProfile(data: UpdateProfileData): Promise<{ response: { user: User } }> {
    const result = await api.put<any>('/users/profile', data)
    return result.response || result
  }

  /**
   * Change user password
   */
  static async changePassword(data: ChangePasswordData): Promise<{ response: { message: string } }> {
    const result = await api.put<any>('/users/change-password', data)
    return result.response || result
  }
}
